import type { FaireProductEntity } from "../../entity_types/product";

export const p_t6gcznwcg2: FaireProductEntity = {
  token: "p_t6gcznwcg2",
  type: "product",
  name: "Thank You 11 oz Soy Candle - Home Decor & Gifts",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/5122ac283b932a53d1a4cd9f4344f8e1f8e97f6cfe03d383fb0fd893907b06ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3b4100a3817fc66a1b9c5c8fbeca0276492cd44239d904242f6a179fea53e28.png",
    "https://cdn.faire.com/fastly/a5685ebbc23da69505dfb831e0cfbdf2053e219a7a7655b33ff5f6cfb489aecc.png",
    "https://cdn.faire.com/fastly/d3eb4a2fd07c95f5525f074214593eef789d18fef2821a28c74c467037925c54.png",
    "https://cdn.faire.com/fastly/24a176350f7d2a1251bcdab383373e46317fc6e3cc3a63463128874701ddc70d.png",
    "https://cdn.faire.com/fastly/d7cddebf9e179ba282882bd32bd35835781fbe4b5424daf77c450de86a3b2c3d.png",
    "https://cdn.faire.com/fastly/4584a8d049bfebb24deabd581b2281358c29b20f4f942f53d18f3ee1e58cdda6.png",
  ],
  priceDollars: 16,
  description:
    'Scent: Island Air\n\nᵞᵟᵒᵟᵡ ᵀᵜᵡᵒᵠ:\n• Top: Tropical Fruits\n• Middle: Sugared Oranges, Lemons and Limes\n• Base: Redolent with Lightly Exotic Mountains Greens\n\nᵞᵒᵟᵑᵟᵒ ᵀᵟᵓᵜ:\n• Size: Volume 11oz | 214g Net Weight | 3x3x3.5"\n• Burn Time: 50+ Hours\n• Wick: 100% Cotton (Lead and Zinc Free)\n• Wax: Proprietary Soy Based Wax Blend | Vegan, Non-GMO, Kosher\n• Premium Fragrance Oil\n• Gluten Free, Phthalate Free, Non-Toxic\n• Made in Pittsburgh, PA\n• Style No. WJ001\n\nᵞᵒᵟᵑᵟᵒ ᴼᵒᵣᵒ:\n• Always Trim Your Wick to 1/4" Before Candle is Lit\n• Burn Candle so Wax Pool Reaches the Jar Edge Each Time to Prevent Wax Tunneling\n• Burn Candle No More Than 4 Hours at a Time and Do Not Burn Candle with Less Than a 1/2" of Wax Remaining\n• Keep Candle Away from Fans, Open Windows, Hot Surfaces, Children, Pets\n• Never Leave a Burning Candle Unattended\n\nTeacher Gifts, Gifts of Appreciation, Neighbor Gifts, Gifts for Parents, Mothers Day, Spring, Easter, Boho, Farmhouse Decor, Spring Decor, Insider Free Shipping',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:04.514Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
